import { RadialProgress } from '../ui/daisy';

type PerformanceCardProps = {
  performance: number;
  title?: string;
  description?: React.ReactNode;
  radialProgressChildren?: string;
};

export function PerformanceCard({
  performance,
  title,
  description,
  radialProgressChildren,
}: PerformanceCardProps) {
  return (
    <div className="bg-base-100 rounded-2xl border border-base-content/10 gap-4 p-4 flex h-36 items-center">
      <RadialProgress
        value={performance}
        color="success"
        children={radialProgressChildren}
        classNames={{ base: 'bg-base-200' }}
      />
      <div className="flex flex-col">
        <h3 className="font-semibold text-base-content">{title}</h3>
        <p className="text-base-content/70 text-sm">{description}</p>
      </div>
    </div>
  );
}
